import { useFormContext } from "react-hook-form";
import PinVerification from "../../../components/pin-verification/pin-verification";

const PhoneVerificationCode = () => {
  const { watch } = useFormContext();
  const formValues = watch();

  return (
    <PinVerification
      title={"Phone number verification code"}
      description={
        <>
          Please enter the 6 digit code we have sent to your phone number{" "}
          <strong>{formValues?.mobile}</strong>.
        </>
      }
      number={formValues?.mobile}
      email={formValues?.email}
      verificationType="number"
    />
  );
};

export default PhoneVerificationCode;
